import styled from 'styled-components';

export const Nav = styled.nav`
  width: 100%;
  height: 4em;
  padding: 2rem;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 100;

  @media screen and (max-width: 768px) {
    padding: 1.5rem 1rem;
    height: 3.5em;
  }

  @media screen and (max-width: 480px) {
    padding: 1rem 0.5rem;
    height: 3em;
  }
`;

export const NavWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 90px;
  width: 90%;

  @media screen and (max-width: 768px) {
    width: 95%;
    min-height: 70px;
  }

  @media screen and (max-width: 480px) {
    width: 100%;
    min-height: 60px;
  }
`;

export const LogoImg = styled.img`
  max-height: 100%;
  height: 80px;
  width: auto;
  margin-left: 3em;
  object-fit: contain;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  padding: 0.5rem;
  border: 2px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;

  &:hover {
    border-color: rgba(255, 255, 255, 0.3);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
    transform: scale(1.05);
  }

  @media screen and (max-width: 768px) {
    margin-left: 1rem;
    height: 60px;
  }

  @media screen and (max-width: 600px) {
    margin-left: 0.5rem;
    height: 50px;
  }

  @media screen and (max-width: 480px) {
    height: 45px;
  }
`;

export const ConnectButton = styled.button`
  padding: 1rem 2rem;
  margin-right: 2rem;
  border-radius: 14px;
  align-self: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(10px);
  font-weight: 700;
  font-family: 'Poppins', sans-serif;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  color: #fff;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
  }

  &:active {
    transform: translateY(0px);
  }

  @media screen and (max-width: 768px) {
    padding: 0.9rem 1.5rem;
    font-size: 0.95em;
  }

  @media screen and (max-width: 480px) {
    padding: 0.8rem 1.2rem;
    font-size: 0.9em;
    margin-right: 1rem;
  }
`;
